export const normalizeAuthEmail = (email) => String(email || '').trim().toLowerCase();

export function authErrorMessage(error) {
  if (error?.status === 429) return 'För många försök. Vänta en stund och försök igen.';
  if (error?.status >= 500) return 'Inloggningstjänsten svarar inte som den ska. Försök igen om en stund.';
  if (error?.code === 'invalid_credentials' || error?.message === 'Invalid login credentials') {
    return 'E-postadressen eller lösenordet stämmer inte. Kontrollera uppgifterna eller välj Glömt lösenord.';
  }
  if (error?.code === 'email_not_confirmed') return 'E-postadressen behöver bekräftas innan du kan logga in.';
  return 'Ett tekniskt fel uppstod vid inloggningen. Försök igen om en stund.';
}
